module.exports = __webpack_public_path__ + "img/arrow.2b3c901.png";